import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  Button,
  CircularProgress
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Capacitor } from '@capacitor/core';
import { CapacitorWechat } from '@capgo/capacitor-wechat';
import { isWechatInstalled } from '../../../utils/wechat/share';
import { toast } from 'react-toastify';
import IconToast from '../../../components/NewToast';
import { Browser } from '@capacitor/browser';
import { withRouter } from 'react-router';

const WechatLoginButton = ({ intl, history, loginUser, loginPhase, loginMessage, loginMessageExtras, userDetails, disabled }) => {
  const [loading, setLoading] = useState(false);
  const pendingWechatLogin = useRef(false);
  const prevLoginPhase = useRef(loginPhase);
  const theme = useTheme();
  const isWeb = Capacitor.getPlatform() === 'web';

  useEffect(() => {
    const prev = prevLoginPhase.current;
    prevLoginPhase.current = loginPhase;

    if (!pendingWechatLogin.current) return;

    if (loginPhase === false && prev !== false) {
      pendingWechatLogin.current = false;
      if (Capacitor.getPlatform() === 'ios') {
        toast.info(IconToast('error', intl.formatMessage({ id: 'no-portfoplus-account-bound-please-contact-us' })), { className: 'new-toast' });
      } else if (loginMessage === 'wechat-not-bound') {
        const params = new URLSearchParams({ campaignCode: 'wechat' });
        if (Capacitor.isNativePlatform()) {
          params.set('source', 'capacitor');
        }
        history.push(`/userType?${params.toString()}`);
      }
      setLoading(false);
    }

    if (loginPhase === true && prev !== true) {
      pendingWechatLogin.current = false;
      setLoading(false);
    }
  }, [loginPhase, loginMessage, loginMessageExtras, userDetails]);

  const handleWechatLogin = useCallback(async () => {
    if (isWeb) {
      // Web: redirect to WeChat OAuth QR code page
      const redirectUri = encodeURIComponent(window.location.origin + '/login');
      const authUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=${process.env.WECHAT_WEBSITE_APP_APP_ID}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_login&state=pfplus_wechat_login#wechat_redirect`;
      window.location.href = authUrl;
      return;
    }

    const installed = await isWechatInstalled();
    if (!installed) {
      toast.info(IconToast('error', intl.formatMessage({ id: 'wechat-not-installed' })), {
        className: 'new-toast'
      });
      return;
    }

    setLoading(true);

    try {
      const { code } = await CapacitorWechat.auth({
        scope: 'snsapi_userinfo',
        state: 'pfplus_login'
      });

      pendingWechatLogin.current = true;
      loginUser({ wechatCode: code });
    } catch (error) {
      console.error('WeChat login error:', error);
      setLoading(false);
    }
  }, [intl, loginUser]);

  return (
    <>
      <Button
        onClick={handleWechatLogin}
        disabled={disabled || loading}
        style={{ minWidth: 'unset', padding: 6, borderRadius: '50%' }}
      >
        {loading ? (
          <div style={{ width: 30, height: 30, borderRadius: '50%', backgroundColor: '#07C160', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress size={20} style={{ color: '#FFFFFF' }} />
          </div>
        ) : (
          <img src="/img/wechat-green.svg" alt="WeChat" style={{ width: 30, height: 30 }} />
        )}
      </Button>
    </>
  );
};

export default withRouter(WechatLoginButton);
